import { useCallback, useMemo, useState } from "react";

import type * as Type from "./type";

type Props = {
	// 色（オプション）ごとにまとめてタイムライン表示する
	groupByOptionID: boolean;
};

export const useViewModel = ({ groupByOptionID }: Props) => {
	const [selectedCardID, setSelectedCardID] = useState<string | undefined>(undefined);

	const viewModel = useMemo<Type.ViewModel>(
		() => ({ selectedCardID, groupByOptionID }),
		[selectedCardID, groupByOptionID],
	);

	/**
	 * オプションの選択
	 */
	const onSetCardIDOfOption = useCallback((cardID?: string) => {
		setSelectedCardID(cardID);
	}, []);
	/**
	 * オプションの選択解除
	 */
	const onClearCardIDOfOption = useCallback(() => {
		setSelectedCardID(undefined);
	}, []);

	return {
		//
		viewModel,
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
	};
};
